export enum ApartmentType {
  ApartmentBuilding = 'Apartment building',
  DetachedHouse = 'Detached house',
  Townhouse = 'Townhouse/semi-detached house',
}
